import { render } from "./FriendlyCaptchaField.vue?vue&type=template&id=b1a20166&scoped=true"
import script from "./FriendlyCaptchaField.vue?vue&type=script&lang=js"
export * from "./FriendlyCaptchaField.vue?vue&type=script&lang=js"

import "./FriendlyCaptchaField.vue?vue&type=style&index=0&id=b1a20166&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1a20166"]])

export default __exports__